import { vnModule_knockoutJS } from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import { XMLHttpRequestHandler } from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import { videosView_template } from "../components/templates/videosView_template";
import { header } from "./header";

declare var ko: any;
declare var page: any;

export class videos_view extends vnModule_knockoutJS {
    protected viewTemplate: videosView_template;
    protected XHRHdl: XMLHttpRequestHandler;

    protected getModuleName(): string {
        return "videos_view";
    }

    public buildContent(): Array<Element> {
        this.viewTemplate = new videosView_template("view_template", this.viewModel, this);
        this.template = this.viewTemplate;

        let zoneHeader = this.getVnAppZone().app.getZoneByName("Header");
        let loadedModule = zoneHeader.loadedModule;
        (<header>loadedModule).setHeaderTitle("Videos List");

        return [this.viewTemplate.build()];
    }

    public fillPage(): void {
        this.getData();
    }

    protected getData() {
        this.loadingIn(this.viewTemplate.builtTemplate);
        let usrReq_url: string =
            "/api/brand/" + this.getVnAppZone().app.params.idBrand + "/videos/get/" + this.getVnAppZone().app.params.id;
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(this.viewTemplate.getViewModelForRequest())]);
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
        this.XHRHdl.onReadyStateFunction = this.onGetData;
        this.XHRHdl.execute();
    }

    protected onGetData(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {
                let responseParsed = JSON.parse(req.request.response);
                obj.setUpForm(responseParsed.data);
            });
            obj.loadingOut(obj.viewTemplate.builtTemplate);
        };
    }

    public setUpForm(data): void {
        let producer =
            data.video.details !== null && data.video.details.producer !== null ? data.video.details.producer : null;
        let producerFullName =
            producer !== null && producer.valnet_user !== null && producer.valnet_user.fullNameAndLogin !== null
                ? producer.valnet_user.fullNameAndLogin
                : null;

        let primaryTag =
            data.video.details !== null && data.video.details.idPrimaryTag !== null
                ? data.video.details.primaryTag.name + " " + data.video.details.primaryTag.formattedTagTypeAndDataset
                : null;

        let primaryCategory =
            data.video.details !== null && data.video.details.idPrimaryCategory !== null
                ? data.video.details.primaryCategory.name
                : null;

        let contentType =
            data.video.details !== null && data.video.details.contentType !== null
                ? data.video.details.contentType.name
                : null;

        this.viewTemplate.setId(data.video.id);
        this.viewTemplate.setTitle(data.video.title);
        this.viewTemplate.setDescription(data.video.description);
        this.viewTemplate.setUrl(data.video.url);
        this.viewTemplate.setLength(data.video.length);
        this.viewTemplate.setSize(data.video.size);
        this.viewTemplate.setSizeHuman(data.video.size);
        this.viewTemplate.setHeight(data.video.height);
        this.viewTemplate.setWidth(data.video.width);
        this.viewTemplate.setRatio(data.video.ratio);
        this.viewTemplate.setMimeType(data.video.mimeType);
        this.viewTemplate.setDateCreated(data.video.dateCreated);
        this.viewTemplate.setDateUpdated(data.video.dateUpdated);
        this.viewTemplate.setProducer(producerFullName);
        this.viewTemplate.setThumbnail(data.video.thumbnail.url);
        this.viewTemplate.setIsUnderEmbargo(data.video.isUnderEmbargo);
        this.viewTemplate.setIsEditShown(true);

        this.viewTemplate.setPrimaryTag(primaryTag);

        let tags = [];
        if (data.video.videoTags) {
            data.video.videoTags.forEach((t) => {
                let tag = t.tag.name;
                if (t.tag.type != null) {
                    tag = tag + " " + t.tag.formattedTagTypeAndDataset;
                }
                tags.push(tag);
            });
            this.viewTemplate.setTags(tags.join(", "));
        }

        this.viewTemplate.setPrimaryCategory(primaryCategory);

        let categories = [];
        if (data.video.videoCategories) {
            data.video.videoCategories.forEach((t) => {
                let category = t.category.name;
                categories.push(category);
            });
            this.viewTemplate.setCategories(categories.join(", "));
        }

        this.viewTemplate.setContentType(contentType);

        let subtitles = [];
        if (data.video.videoSubtitles) {
            data.video.videoSubtitles.forEach((t) => {
                subtitles.push(t.language.name + " (" + t.type + ")");
            });
            this.viewTemplate.setSubtitles(subtitles.join(", "));
        }
        this.viewTemplate.setVideoArticleId(data.videoArticleId);
    }

    protected edit(id) {
        page("/brand/" + this.getVnAppZone().app.params.idBrand + "/videos/edit/" + id);
    }

    protected goBack() {
        let previousUrl = this.loadPreviousPage(window.location.href);
        if (previousUrl) {
            page.redirect(previousUrl);
        } else {
            page.redirect("/brand/" + this.getVnAppZone().app.params.idBrand + "/videos");
        }
    }

    public generateVideoArticle(data, videoArticleId) {
        
        
        let link : string  = "/brand/" + this.getVnAppZone().app.params.idBrand 
        if(videoArticleId){
            link += "/articles/view/" +videoArticleId;
            window.open(link, "_blank");    
        }else{
            
            link += "/articles/add?videoId="+data.id();           

            // Open the URL in a new tab
            window.open(link, '_blank');
        }

    }
}



// WEBPACK FOOTER //
// ./js/modules/videos_view.ts